export default __webpack_public_path__ + "c642d226e2e3e22ab27d27decf72c8ed.svg";